import { AppState } from "../app.state";
import { ILocalFerkelDto } from "../../db/database";

export const getFilteredFerkel = (state: AppState): ILocalFerkelDto[] => state.ferkel.filteredFerkel;

export const getFerkelStatus = (state: AppState) => state.ferkel.loadStatus;

export const getLastFetchedDate = (state: AppState) => state.ferkel.lastFetched;
